import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { BrowserRouter, Route,useLocation } from 'react-router-dom'
import { refreshWindowDimensions } from '../store/window-dimensions'
import styled from 'styled-components/macro'
// import LoadingData from './components/LoadingData'
import PageMap from './PageMap'
// import config from '../config'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: auto;
`

const App = () => {
    const dispatch = useDispatch()
    const paramHideHeader = (new URLSearchParams(useLocation().search)).get('header') === 'false'
    const paramHideFooter = (new URLSearchParams(useLocation().search)).get('footer') === 'false'
    
    useEffect(() => {
        const dispatchRefreshWindowDimensions = () =>
            dispatch(refreshWindowDimensions())
        window.addEventListener('resize', dispatchRefreshWindowDimensions)
        return () => {
            window.removeEventListener(
                'resize',
                dispatchRefreshWindowDimensions
            )
        }
    }, [dispatch])

    return (

        <PageMap paramHeader={paramHideHeader} paramFooter={paramHideFooter}/>
    )
}

export default App
